import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-unlock-settings',
  templateUrl: './unlock-settings.component.html',
  styleUrls: ['./unlock-settings.component.css']
})
export class UnlockSettingsComponent implements OnInit {
	resObjComp: any;
	compData: any;
	respObject: any;
	configData: any;

	dataType = "";
	fileYear="";
	fullYear: number = new Date().getFullYear();
	yearArr= [];
	yearfArr= [];
	filefYear="";
	selectMonth="";
	fileQuarter="";
	companyId="";

	perPageRow = this._rest.PER_PAGE_ROW;
	curPage = 1;
	totalRows = 0;
	pages = [];
	noOfRows=0;
	constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }

	ngOnInit(): void {
		this.dataType = "";
		this.selectMonth="";
		this.fileQuarter="";
		this.companyId="";
		const co = {}
	    this._rest.companyList(co).subscribe((res) => {
	      this.resObjComp = res;
	      this.compData = this.resObjComp.details;
	    });
	    for (var i= this.fullYear-4;i<=this.fullYear;i++){
		  this.yearArr.push(i);
		  //this.fileYear= i+"";
		}
		for (var i= this.fullYear-4;i<=this.fullYear;i++){
		  this.yearfArr.push(i+"-"+(i+1));
		  //this.filefYear = i+"-"+(i+1);
		}
		this.searchSettings(1);
	}
	searchSettings(curPage){
		this.configData=[];
		this.curPage = curPage;
	    var fd = {};
	    fd["limit"]=this.perPageRow;
	    fd["page"]=this.curPage;
	    fd["templateType"]=this.dataType;
	    if(this.dataType == "Segment"){
	      fd["year"]=this.fileYear;
	      fd["monthly"]=this.selectMonth;
	    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
	      fd["year"]=this.filefYear;
	      fd["quarterly"]=this.fileQuarter;
	    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){     
	      fd["year"]=this.filefYear;
	    }
	    console.log(fd);
	    this._rest.getUnlockConfig(fd).subscribe((res) => {
	      this.respObject = res;
	      
	      if(this.respObject.error==0){
	        this.configData=this.respObject.resp.data;
	        this.totalRows = this.respObject.resp.info;
	        this.noOfRows=this.respObject.resp.data.length;
	        this.pages=[];
	        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
	          this.pages.push(i);
	        }
	      } else {
	        this.configData=[];
	        this.totalRows = 0;
	        this.noOfRows = 0;
	        this.pages=[];
	      }
	    });
	}
	addSettings(){
		var errCounter = 0;
		var fd = {};
	    fd["templateType"]=this.dataType;
	    if(this.dataType==""){
	    	errCounter++;
	    }
	    if(this.dataType == "Segment"){
			if(this.fileYear==""){
	    		errCounter++;
	    	}
	    	if(this.selectMonth==""){
	    		errCounter++;
	    	}
	      	fd["year"]=this.fileYear;
	      	fd["month"]=this.selectMonth;
	    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){
	    	if(this.filefYear==""){
	    		errCounter++;
	    	}
	    	if(this.fileQuarter==""){
	    		errCounter++;
	    	}     
	      	fd["year"]=this.filefYear;
	      	fd["quarter"]=this.fileQuarter;
	    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){
	    	if(this.filefYear==""){
	    		errCounter++;
	    	}     
	      	fd["year"]=this.filefYear;
	    }
	    fd["companyId"]=this.companyId;
	    console.log(fd);
	    if(errCounter==0){
		    this._rest.saveUnlockConfig(fd).subscribe((res) => {
		      this.respObject = res;	      
		      if(this.respObject.error==0){
		        alert("New settings has been added successfully.");
		        this.dataType = "";
				this.selectMonth="";
				this.fileQuarter="";
				this.companyId="";
				this.fileYear="";
				this.filefYear="";
		        this.searchSettings(1);
		      } else {
		        alert(this.respObject.errorMessage);
		      }
		    })
		} else {
			alert("* are required fields.");
		}		
	}
	delteSettings(id){
		if(confirm("Are you sure to delete the settings?")){
			var fd = {"id":id};
			this._rest.delUnlockConfig(fd).subscribe((res) => {
				this.respObject = res;	
				if(this.respObject.error==0){
					alert("The settings has been deleted successfully.");
					this.searchSettings(1);
				} else {
			      alert(this.respObject.errorMessage);
			    }     
			});
		}
	}

}
